var tw = tw || {};
tw.GeopointReports = (function () {
	var _log = false,
		isTouch = $('html').hasClass('touch'),
		initLoadResize = true,
		activeRoute = null,
		reportType = $("[data-reporttype]").data("reporttype"),
		baseTitle = $("[data-metatitlebase]").data("metatitlebase"),
		host = window.location.host,
		protocol = (window.location.protocol == 'https') ? 'https' : 'http',
		basePath = decodeURIComponent($("[data-basepath]").data("basepath")),
		baseUrl = protocol + '://' + host + basePath + '/',
		imgBaseUrl = '', //"http://www.travelwisconsin.com",

		baseCategory = 'Selfie Stand',
		baseAction = 'Selfie Stand',
		urlParams = BingMap.Utilities.getUrlParams(),
		currentReportPane;

	if (_log) console.log('urlParams:', urlParams);
	if (_log) console.log('basePath:', basePath);
	if (_log) console.log('reportType:', reportType);

	var $subpanes = $('.js-subpane'),
		$pane = $('.js-pane'),
		$paneIntro = $('.js-pane-intro'),
		$reportButtons = $('.js-report-button'),
		$subpaneButtons = $('.js-subpane-button'),
		$filterButton = $('.js-filter-button'),
    $map = $('.js-report-map'),
    $intro = $('.js-pane-intro'),
		filterButtonOffset;


	const YEAR = new Date().getFullYear(); 

	//report titles for Google Analytics and Page Title
	//DSR request specific GA/Page titles
	//NOTE: PageTitle is different that gaLong on purpose. Keep updated in tandem with /Controllers/GeopointReports lines ~70-100
	var reportTitles = {
		selfie: {
			gaShort: 'Selfie Stand',
			gaLong: 'Selfie Stand',
			pageTitle: 'Selfie Stand Finder | ' + YEAR + ' Selfie Stand Map'
		},
		crosscountry: {
			gaShort: 'Cross Country',
			gaLong: 'Cross Country Skiing',
			pageTitle: 'Snow Conditions | Cross Country Ski Report'
		},
		downhill: {
			gaShort: 'Downhill',
			gaLong: 'Downhill and Snowboarding',
			pageTitle: 'WI Snow Conditions | Downhill Ski Report'
		},
		snowmobile: {
			gaShort: 'Snowmobile',
			gaLong: 'Snowmobile',
			pageTitle: 'Snow Report | Snowmobile Trail Conditions'
		},
		fallcolor: {
			gaShort: 'Fall Color',
			gaLong: 'Fall Color',
			pageTitle: 'Fall Color Report | ' + YEAR + ' Fall Color Map'
		}

	};



	/**
	 * LAZYLOAD    (https://github.com/verlok/lazyload)
	 * Usage Example: 
	 * <img src="" data-src="path/to/image.ext" class="js-lazy" alt="">
	 * After load, if adding more JS-Lazy items to the stage, run this: crLazyLoad.update();
	 */
	var crLazyLoad = new LazyLoad({
		elements_selector: '.js-lazy'
	});

  var checkFixed = function () {
    var currentPos = $(window).scrollTop();
    var body = $('body');

    if (isLargeLayout() === false) { 
	  if (_log) console.log("is large layout false");
      if (currentPos !== 0 && !body.hasClass('fixed') && !$('.js-reports').hasClass('is-hidden')) {
        body.addClass('fixed');

      } else if (currentPos === 0 && body.hasClass('fixed') || $('.js-reports').hasClass('is-hidden')) {
        body.removeClass('fixed');
        }
    }

    //console.log("currentPos " + currentPos + " filter offset" + filterButtonOffset);
    if (currentPos > filterButtonOffset && isLargeLayout() === false) {
      $filterButton.addClass('fixed');
    } else if (currentPos <= filterButtonOffset && isLargeLayout() === false) {
      $filterButton.removeClass('fixed');
    }
  }


	/**
	 * Initialize Page
	 * */
	var initializePage = function () {
		if (_log) console.group('tw.GeopointReports.initializePage()');

		if (_log) console.log('isTouch', isTouch);
		if (_log) console.log('baseUrl', baseUrl);
		if (_log) console.log('baseTitle:' + baseTitle);
		if (_log) console.log('reportType:' + reportType);

		$("[data-route='" + reportType + "']").addClass('is-active');
		activeRoute = reportType;

		BingMap.Map.initializeButtons();
		BingMap.Map.updateReportType(reportType);
		tw.GeopointReportsListings.getAllReportsByRegion();

		var useHref = '';
		useHref = basePath

		var txt = activeRoute,
			href = useHref,
			obj = {
				path: href,
				text: txt
			};
		//window.history.pushState(obj, txt, href);
		//if (_log) console.log('window.history.pushState(' + JSON.stringify(obj) + ', ' + txt + ', ' + href + ')');


		$('body').on('click', '.js-report-expand', function () {
			var thisId = $(this).data('id');
			//if (_log) console.log('.js-report-expand.id:', thisId);
			tw.GeopointReportsListings.getReportDetails(thisId);

			var loc = $(this).data('title');
			tw.Analytics.ga4(baseCategory, 'Location Click', loc);
			console.log('js-report-expand', baseCategory, 'Location Click', loc);
		});


		$('body').on('click', '.js-reset-map', function () {
			$('#filter-condition-open').prop("checked", false);
			BingMap.Map.togglePushpinCluster(false);
			BingMap.Map.softResetMap();
		});

		
		$('body').on('click', '.cr__asset__button', function () {
			tw.Analytics.ga4('Selfie Stand Finder', 'ScenicWisconsin Enlarge Photo', $('#loaderUGC').attr('data-title'));
		});

		$('body').on('click', '.fullscreen__ahref', function () {
			tw.Analytics.ga4('Selfie Stand Finder', 'ScenicWisconsin Open Photo in Instagram', $('#loaderUGC').attr('data-title'));
		});
		

		$('body').on('click', '.fullscreen__next', function () {
			tw.Analytics.ga4('Selfie Stand Finder', 'ScenicWisconsin Photo Click', 'Next');
		});

		$('body').on('click', '.fullscreen__previous', function () {
			tw.Analytics.ga4('Selfie Stand Finder', 'ScenicWisconsin Photo Click', 'Previous');
		});

		$('body').on('click', '.infoLink', function () {
			tw.Analytics.ga4('Selfie Stand Finder', 'ScenicWisconsin Photo Click', 'Open in Instagram');
		});
		

    $('body').on('click', '.js-pane-intro-dismiss', function () {
      dismissIntro();
    });

    $(window).smartscroll(function () {
      if ($(window).scrollTop() > 50 && !$intro.hasClass('hidden')) {
        dismissIntro();
        $(window).scrollTop(0);
      }
    });

		//opening subpanes
		$subpaneButtons.click(function () {
			//if (_log) console.log('$subpaneButtons.click');
			checkDestination($(this));
		});



		$('.js-map-hide').click(function () {
			hideMap();
			tw.Analytics.ga4('Selfie Stand Finder', 'Mobile Map Toggle', 'Hide');
		});

		$('.js-map-show').click(function () {
			showMap();
			tw.Analytics.ga4('Selfie Stand Finder', 'Mobile Map Toggle', 'Show');
		});

		$('.js-reports-filter').change(function () {
			var isChecked = $(this).is(":checked");
			//console.log('.js-reports-filter.isChecked:', isChecked);
			BingMap.Map.togglePushpinCluster(isChecked);
		});



		/**
		 * Listener for browser Back button
		 */
		window.addEventListener('popstate', function (e) {
			if (_log) console.log('popstate.e: ', e);
			if (_log) console.log('popstate.e.state: ', e.state);
			if (e.state != null && e.state != undefined) {
				var route = e.state.text;
				if (_log) console.log('popstate.route: ', route);
				reportType = route;
				closeSubpanes();
				$('body').removeClass('is-hidden-map');
				$('.js-report-button[data-route="' + route + '"]').addClass('is-active');
				changeUrl(route);
			}

		});

		$(window).smartscroll(function () {
      checkFixed();
		}).scroll();

		$pane.smartscroll(function () {
			var currentPos = $pane.scrollTop();

			if (currentPos > filterButtonOffset && isLargeLayout() === true) {
				$filterButton.addClass('fixed');
			} else if (currentPos <= filterButtonOffset && isLargeLayout() === true) {
				$filterButton.removeClass('fixed');
			}
		}).scroll();

		$(window).smartresize(function () {
			if (_log) console.log('smartresize.initLoadResize:', initLoadResize);
			if (!initLoadResize) {
				BingMap.Map.trackResize();
			}
			initLoadResize = false;

			setFilterButtonOffset();

			if (isLargeLayout() === true) {
				$('body').addClass('fixed');
			}

    }).resize();

    /* Need to rearrange the nav to allow the open nav to not be fixed, otherwise users can't get to off-screen nav items */
    $('.js-global-nav').appendTo('.js-header-container');


		if (_log) console.groupEnd();

	}

	var setFilterButtonOffset = function () {
		if (isLargeLayout() === true) {
			filterButtonOffset = $paneIntro.height();
		} else {
			filterButtonOffset = $map.height();
		}
		
		if (_log) console.log('filterButtonOffset:', filterButtonOffset);
	}

	/**
	 * Check for Deeplink, load details if found
	 * sample: /selfie-stand?type=report&id=1982
	 */
	var checkForDeeplink = function () {
		if (_log) console.log('checkForDeeplink() LOOK FOR DEEPLINK');

		if (urlParams['type'] != null && urlParams['id'] != null && urlParams['id'] > 0) {
			if (_log) console.log('DEEPLINK TO REPORT.ID: ', urlParams['id']);
			var id = urlParams['id'],
				maxCheck = 30;

			var deepInt = setInterval(function () {
				var btn = $('button[data-id="' + id + '"]'),
					title = $(btn).data('title');
				if (_log) console.log('btn.title: ', title);
				if (_log) console.log('btn.width():', btn.width());

				if (btn.width() > 5) { //btn now exists, open report
					clearInterval(deepInt);

					tw.GeopointReportsListings.getReportDetails(id);

					tw.Analytics.ga4(baseCategory, 'Deep Link', title);
				}
				//try to find it for a bit, but then stop looking
				maxCheck--;
				if (maxCheck == 0) {
					clearInterval(deepInt);
				}
			}, 400);
		}

	}


	/**
	 * (RE)Initialize Map, only called once
	 * Get Counties Shape data before initializing map
	 * */
	var initializeMap = function (report) {
		if (_log) console.log('initializeMap()');
		BingMap.Map.initializeMap({
			ReportType: report,
			CountyData: $("[data-countydata]").data("countydata")
		});
		checkForDeeplink();
	};




	/**
	 *Change url, update nav, pagetitle, get map, update panes
	 */
	var changeUrl = function (route) {
		if (_log) console.log('changeUrl(' + route + ')');
		activeRoute = route;
		updatePageTitle();
		initializeMap(route); //initmap before region, updates reportType
	};

	/**
	 * Get report title
	 */
	var getReportTitle = function (type) {
		//console.log('getReportTitle()', type); 
		var title = reportTitles[reportType][type];
		//console.log('title:', title);
		return title;
	}


	/**
	 * Update page title
	 */
	var updatePageTitle = function () {
		//if (_log) console.log('updatePageTitle()');
		var reportTitle = getReportTitle('pageTitle');
		var pageTitle = reportTitle + ' ' + decodeURIComponent(baseTitle);
		//console.log('pageTitle: ', pageTitle);
		document.title = pageTitle;
	};


	var isLargeLayout = function () {
		//if (_log) console.log('isLargeLayout()');
		var breakpoint = window.matchMedia("(min-width: 1023px)").matches === true;
		return breakpoint;
	}


	var setPaneRecords = function (subpaneId) {
		if (subpaneId) {
			currentReportPane = subpaneId;
		} else {
			/* If it's all reports, then it will have no subpaneId */
			currentReportPane = undefined;
		}
		if (_log) console.log('setPaneRecords.currentReportPane:', currentReportPane);
	}

	var getPaneRecords = function () {
		return currentReportPane;
	}


	var openSubpane = function (options) {
		if (_log) console.log('openSubpane.options', options);
		var subpaneId = options.subpane,
			$thisSubpane = $subpanes.filter('[data-subpane="' + subpaneId + '"]');
		//don't do anything if a valid subpane ID hasn't been provided
		if (subpaneId === "gallery") {
			initializeGallery();
		}

		if ($thisSubpane.length > 0) {
			//only one subpane can be open at a time
      $(window).scrollTop(0);

			closeSubpanes();

			if ($thisSubpane.hasClass('is-hidden')) {
				$thisSubpane.removeClass('is-hidden');
			}

			if (subpaneId == 'share') {
				//update form URL hidden input
				resetFormShare();
			}

			tw.GeopointReportsListings.hideReports();

		}

		

	};



	/**
	 * Reset all Panes, give access to external files
	 */
	var resetAllPanes = function () {
		closeSubpanes();
		tw.GeopointReportsListings.showReports();
	}

	var closeSubpanes = function () {
		//console.log('closeSubpanes()');
		$subpanes.addClass('is-hidden');
	}

	var setActive = function (subpaneId) {
		//console.log("setting active button: " + subpaneId);
		//find buttons that belong to the currently active pane and make them active, even if they weren't the button used to launch the pane
		$subpaneButtons.filter('[data-subpane="' + subpaneId + '"]').addClass('is-active');
	}

	var hideMap = function () {
		$('body').addClass('is-hidden-map');
		setFilterButtonOffset();
	}

	var showMap = function () {
		$('body').removeClass('is-hidden-map');
		setFilterButtonOffset();
  }

  var dismissIntro = function () {
    $intro.addClass('hidden');
  }

	var getPaneInfo = function () {
		var json = {
			'isOpen': !$pane.hasClass('is-hidden'),
			'width': $pane.width()
		};
		if (_log) console.log('getPaneInfo: ', json);
		return json;
	}



	var checkDestination = function (button) {
		//if(_log)console.log("checkDestination: ", button);
		var thisSubpane = button.attr('data-subpane'),
			//optional ID of subpane to return to
			returnTo = button.attr('data-return');

		/* If returnTo is true, get the ID of the last report pane user was on and send them back there */
		if (returnTo === "true") {
			thisSubpane = getPaneRecords();
		}

		//if button does not specify a subpane to open (e.g. subpane back buttons) then show the reports
		if (thisSubpane) {
			openSubpane({
				subpane: thisSubpane,
				returnTo: returnTo
			});
		} else {
			closeSubpanes();
			BingMap.Map.softResetMap();
			tw.GeopointReportsListings.showReports();
		}
	}


	/**
	* Initialize main photo gallery
	*/
	var initializeGallery = function () {
		var galleryId = "cr-init__3051b7d3df022ad8";
		tw.GeopointReportsListings.initializeUGC(galleryId, "gallery");
	}

	$(initializePage); //doc ready

	return {
		closeSubpanes: closeSubpanes,
		getPaneInfo: getPaneInfo,
		getReportTitle: getReportTitle,
		initializeMap: initializeMap,
		openSubpane: openSubpane,
		resetAllPanes: resetAllPanes,
		setPaneRecords: setPaneRecords,
		isLargeLayout: isLargeLayout,
		checkFixed: checkFixed
	}
}());